angular.module('NiacsProjectApp.browser',[
    'templates-niacs',
    'NiacsProjectApp.filters',
    'NiacsProjectApp.services',
    'NiacsProjectApp.browser.misc',
    'ui.bootstrap',
    'ngCookies',
])
.directive('niacsBrowser',['$uibModal','NiacsBrowserUtils','NiacsBrowserMapStyles', '$cookies', function($uibModal,NiacsBrowserUtils,NiacsBrowserMapStyles, $cookies){
    return {
        restrict: 'E',
        templateUrl: 'browser/browser.html',
        link: function($scope,$element) {
            $scope.mapCanvas = document.getElementById('map-canvas');
            var map = $scope.map = new google.maps.Map($scope.mapCanvas, {
              zoom: 4,
              center: new google.maps.LatLng(38.8402805, -97.61142369999999),
              fullscreenControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              styles: NiacsBrowserMapStyles
            });
            $scope.loading = true;
            
            NiacsBrowserUtils.load(map)
                .then(function() {
                    map.data.addListener('mouseover',function(event) {
                        map.data.revertStyle();
                        map.data.overrideStyle(event.feature,{fillOpacity: 1.0,strokeColor:'#ffffff',strokeWeight:2.0,zIndex:event.feature.getProperty('zIndex')+1});
                        var vulnRegion = NiacsBrowserUtils.getVar(event.feature);
                        $scope.$apply(function() {
                            $scope.tooltip = NiacsBrowserUtils.getVar(event.feature).label;
                            $scope.isState = !vulnRegion.geojson && vulnRegion.state && vulnRegion.state.length;
                        });
                    });
                    map.data.addListener('mouseout',function(event) {
                        map.data.revertStyle();
                        
                        $scope.$apply(function() {
                            delete $scope.tooltip;
                            delete $scope.isState;
                        });
                    });
                    map.data.addListener('click',function(event) {
                        $uibModal.open({
                            templateUrl: 'browser/var-info-dialog.html',
                            controller: 'NiacsBrowserVarInfoCtrl',
                            windowClass: 'niacs-browser-var-info',
                            resolve: {
                                vulnRegion: function() { return NiacsBrowserUtils.getVar(event.feature); }
                            }
                        });
                    });
                    delete $scope.loading;
                   
                });
            $scope.onboarding = function() {
                $uibModal.open({
                    templateUrl: 'browser/onboarding.html',
                    controller: 'NiacsBrowserOnboardingCtrl',
                    windowClass: 'niacs-browser-onboarding'
                });
                
            };
            
            //Test to see if the help dialog cookie exists. If not, show the onboarding dialog and set the cookie so that it does not show up again upon refresh.
            //console.log($cookies.get('help'));
            if(!$cookies.get('help')) {
                $scope.onboarding();
                $cookies.put('help', 'dialog');
            }

        }
    };
}])
.directive('browserUnit',['UserProfileService',function(UserProfileService){
    return {
        restrict: 'C',
        templateUrl:'browser/unit.html',
        scope: {
            unit: '='
        },
        link: function($scope) {
            UserProfileService.get(function(up) { $scope.up = up; });
        }
    };
}])
.directive('browserCis',['UserProfileService',function(UserProfileService){
    return {
        restrict: 'C',
        templateUrl:'browser/cis.html',
        scope: {
            statement: '='
        },
        link: function($scope) {
            UserProfileService.get(function(up) { $scope.up = up; });
        }
    };
}])
.factory('NiacsBrowserUtils',['$q','$http','NiacsVulnAssmntRegion',function($q,$http,NiacsVulnAssmntRegion) {
    var STATES_ID = -1;
    var VAR_KEY = '$VAR';

    // don't like this but trying to assign colors/opacity programmatically
    // results in a map that's just too haphazard in appearance so taking control
    // of colors explicitly, regions are very unlikely to change so this shouldn't be
    // a huge deal...  using the nid in case the name were to change.
    var VAR_COLORS_BY_LABEL = {
        'Greater Chicago Area': '#499029',
        'Central Appalachians': '#285017',
        'Mid-Atlantic': '#69D03B',
        'New England': '#5CB634',
        'Northern WI and western UP': '#285017',
        'Eastern UP and Northern Lower Michigan': '#69D03B',
        'Central Hardwoods': '#5CB634',
        'Northern Minnesota': '#499029',
        'Northwest': '#142634',
        'Southwest': '#2D5474',
        'Great Plains': '#4682B4',
        'Midwest': '#2D5474',
        'Southeast': '#142634',
        'Northeast': '#142634',
        'Alaska': '#4682B4',
        'Hawaii': '#142634',
        'Northern Great Plains': '#4682B4',
        'Southern Great Plains': '#0B3262',
    };

    // takes a list of [Multi]Polygon features and turns them into
    // a GeoJson document containing a single feature build from features.
    function consolidateFeatures(features) {
        return {
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                geometry: {
                    type: 'MultiPolygon',
                    coordinates: features.reduce(function(arr,f) {
                        if(f.geometry.type === 'MultiPolygon') {
                            return arr.concat(f.geometry.coordinates);
                        } else if(f.geometry.type === 'Polygon') {
                            arr.push(f.geometry.coordinates);
                        }
                        return arr;
                    },[])
                }
            }]
        };
    }

    function addGeoJsonForVar(map,json,vulnRegion,zIndex,fillOpacity) {
        map.data.addGeoJson(json)
            .forEach(function(f) {
                f.setProperty(VAR_KEY,vulnRegion);
                f.setProperty('fillColor',VAR_COLORS_BY_LABEL[vulnRegion.label]||'#ff0000');
                f.setProperty('zIndex',zIndex);
                if(typeof(fillOpacity) === 'number') {
                    f.setProperty('fillOpacity',fillOpacity);
                }
            });
        // only called during load, initially have everything hidden until complete
        map.data.setStyle(function(feature) { return {visible: false}; });
    }

    function isStateBasedVar(vulnRegion) {
        return !vulnRegion.geojson && vulnRegion.state && vulnRegion.state.length;
    }
    
    var service = {
        /**
         * Get units for a VAR.
         * @param {object} vulnRegion
         * @returns {Promise}
         */
        getUnits: function(vulnRegion) {
            return vulnRegion.$getUnits();
        },
        /**
         * Get the list of Climate Impact Statements for an object that has them (var or unit).
         * If cisHolder isn an array of cisHolders (list of units) then the promise will resolve
         * a map/hash where the keys are the holder ids and the values are the list of statements.
         * 
         * @param {object||array} cisHolder A VAR or Unit (must have _links.cistatements)
         * @returns {Promise}
         */
        getClimateImpactStatements: function(cisHolder) {
            function statements(holder) { return holder.$getClimateImpacts(); }
            if(Array.isArray(cisHolder)) {
                return $q.all(cisHolder.reduce(function(map,holder) {
                    map[holder.id] = statements(holder);
                    return map;
                },{}));
            }
            return statements(cisHolder);
        },
        /**
         * @param {google.maps.Data.Feature} feature The feature.
         * @return {object} The Vulnerability Assessment Region associated with the feature.
         */
        getVar: function(feature) {
            return feature.getProperty(VAR_KEY);
        },
        /**
         * Load GeoJson and associate final features with their source vulnerability assessment region
         * @param {google.maps.Map} map
         * @returns {Promise}
         */
        load: function(map) {
            var def = $q.defer();
            NiacsVulnAssmntRegion.query(function(results){
                var vars = results.list;
                var toLoad =
                    [{label:'US States',id:STATES_ID,geojson:{self:niacs.ModuleUrl+'/map-data/us-states.topojson'}}]
                    .concat(vars.filter(function(r){ return r.geojson && r.geojson.self;}));
                var promises = toLoad.map(function(o) {
                    return $http.get(o.geojson.self)
                        .then(function(response) {
                            var json = response.data;
                            if(json.type === 'Topology') {
                                json = topojson.feature(json,json.objects[Object.keys(json.objects)[0]]);
                            }
                            if(o.id === STATES_ID) {
                                // break states into multiple GeoJson documents grouping states by the 
                                // VARs that own them so they respond as a group in the map UI.
                                // any states not associated with a VAR will fall away (e.g. Puerto Rico)
                                var states = json.features.reduce(function(map,f) {
                                        map[f.properties.NAME] = f;
                                        return map;
                                    },{});
                                var stateVars = vars.filter(isStateBasedVar);
                                stateVars.forEach(function(vulnRegion) {
                                    addGeoJsonForVar(
                                        map,
                                        consolidateFeatures(vulnRegion.state.map(function(stateName) { return states[stateName]; })),
                                        vulnRegion,
                                        0
                                    );
                                });
                            } else {
                                addGeoJsonForVar(map,json,o,2,0.5);
                            }
                            return true;
                        });
                });
                return $q.all(promises)
                    .then(function() {
                        map.data.setStyle(function(feature) {
                            return {
                                strokeOpacity: 1.0,
                                strokeColor: '#a1bad8',
                                strokeWeight: 1.0,
                                fillColor: feature.getProperty('fillColor'),
                                fillOpacity: feature.getProperty('fillOpacity')||1.0,
                                zIndex: feature.getProperty('zIndex')
                            };
                        });
                        def.resolve();
                    });
            });
            return def.promise;
        }
    };
    return service;
}])
.controller('NiacsBrowserVarInfoCtrl',['$scope','$uibModalInstance','vulnRegion','$q','NiacsBrowserUtils','NiacsStrategyService',function($scope,$uibModalInstance,vulnRegion,$q,NiacsBrowserUtils,NiacsStrategyService) {
    $scope.dismiss = $uibModalInstance.dismiss;
    //console.log('vulnRegion',vulnRegion);
    var sourcesPromise = NiacsStrategyService.getSources()
        .then(function(strategySources) {
            return strategySources.filter(function(ss) {
                return ss.getSourceAlias() !== 'far1' && !ss.isDisabled(); // skip legacy far1
            }).map(function(ss) {
                return { // just 'cuz this is easier than using the functions
                    alias: ss.getSourceAlias(),
                    resource: ss.getSource(),
                    title: ss.getSourceTitle()
                };
            });
        });
    var unitsPromise = NiacsBrowserUtils.getUnits($scope.vulnRegion = vulnRegion);
    var impactsPromise = unitsPromise
        .then(function(units) {
            return NiacsBrowserUtils.getClimateImpactStatements([vulnRegion].concat(units));
        });
    $q.all({
            stratSources: sourcesPromise,
            units: unitsPromise,
            impacts: impactsPromise
        })
        .then(function(results) {
            var stratSources = results.stratSources,
                units = results.units,
                impacts = results.impacts,
                allSectors = stratSources.map(function(ss) { return ss.resource; }).sort();
            function hasSectorFlagged(hasSectors,sector) {
                return hasSectors.sectors && hasSectors.sectors.indexOf(sector) !== -1;
            }
            function allSectorsFlagged(hasSectors) {
                var i;
                if(hasSectors.sectors && hasSectors.sectors.length >= allSectors.length) {
                    return allSectors.reduce(function(all,s) {
                            return !all ? all /* at least one not found */ : hasSectors.sectors.indexOf(s) !== -1 /* is this one not found? */;
                        },true);
                }
                return false;
            }
            // store the impacts on each holder for display
            [vulnRegion].concat(units).forEach(function(holder) {
                holder.$climateImpacts = impacts[holder.id];               
            });
            // build a static object representation of the data to view
            $scope.tabs = [{
                title: 'General',
                // display all climate impacts on general.
                impacts: vulnRegion.$climateImpacts,
                // regional impacts are those that have all sectors flagged, the remainder are sector specific
                //vulnRegion.$climateImpacts.filter(function(imp) { return allSectorsFlagged(imp); }),
                units:[] // none
            }].concat(stratSources
                // this is odd to do this and then map, but the team really doesn't appearo want any sector specific
                // tabs other than forest to show up..  this was designed to be generic so that as sectors/units/impacts were
                // added their data would just show up BUT...
                .filter(function(ss) {
                    return ss.alias === 'far2';
                })
                .map(function(ss) {
                return {
                    title: ss.title+' impacts',
                    impacts: [],
                    /* not displaying any impacts on sector tabs.
                    // sector specific impacts are sourced from the region and are
                    // those flagged for the sector but not all sectors (i.e. not regional).
                    impacts: vulnRegion.$climateImpacts.filter(function(imp) {
                        return hasSectorFlagged(imp,ss.resource) && !allSectorsFlagged(imp);
                    }),*/
                    // units that apply to the given sector and have climate impacts
                    units: units.filter(function(unit) {
                        return unit.$climateImpacts.length && unit.sectors.indexOf(ss.resource) !== -1;
                    })
                };
            }).filter(function(tab) {
                return (tab.impacts.length || tab.units.length > 0); // general always sticks and others only if they have units to display
            }));
            //console.log('TABS',$scope.tabs);
        });
}])
.controller('NiacsBrowserOnboardingCtrl',['$scope','$uibModalInstance' ,function($scope,$uibModalInstance) {
    $scope.dismiss = $uibModalInstance.dismiss;
}]);